import Rotator from './UOE.N2CMS.Helpers.Presentation/UOE.Rotator';
(function ($) {
    $(document).ready(function () {
        var $items = $("div#rotator-contents .rotator-item");
        if ($items.size() == 0) {
            return;
        }
        var rotatorRotator = new Rotator();
        const mediaQueryList = window.matchMedia("screen and (max-width: 991px)");
        if (mediaQueryList.matches) {
            rotatorRotator.initialize($items, { viewTime: 0, createControls: false, randomStart: true });
        }
        else {
            rotatorRotator.initialize($items, { viewTime: 8000, createControls: true, controlParent: $("div#rotator-controls") });
        }
    });
});
